import { environmentDefaults } from './environment.defaults';

export const environment = {
  ...environmentDefaults,
  contentful: {
    ...environmentDefaults.contentful,
    environment: 'master',
  },
  name: 'p1',
  production: true,

  auth: {
    cognitoURI: 'https://prod-1-tasc-bam-admin-ui-new.auth.us-east-1.amazoncognito.com/',
    ClientId: '7084dj3aceggh6qvf1ek2drs9k',
    idpiClientId: '',
    UserPoolId: 'us-east-1_joPxz2hWe'
  },

  logging: {
    apiKey: '0BxPR7kX38K2BZ1FKvfhw',
    debugMode: false
  },

  services: {
    ...environmentDefaults.services,
    idp: {
      endpoint: 'https://uzz3gtbyua.execute-api.us-east-1.amazonaws.com/test/auth/v1'
    },
    core: {
      endpoint: 'https://kzv8c2g0o4.execute-api.us-east-1.amazonaws.com/test'
    },
    communication: {
      endpoint: 'https://p1-api.tascadmin.com/communication/v1'
    },
    configuration: {
      endpoint: 'https://p1-api.tascadmin.com/configuration/v1'
    },
    profile: {
      endpoint: 'https://p1-api.tascadmin.com/profile/v1'
    },
    profileConfiguration: {
      endpoint: 'https://p1-api.tascadmin.com/profileconfiguration/v1'
    },
    account: {
      endpoint: 'https://p1-api.tascadmin.com/account/v1'
    },
    request: {
      endpoint: 'https://p1-api.tascadmin.com/request/v1'
    },
    lookup: {
      endpoint: 'https://p1-api.tascadmin.com/lookup/v1'
    },
    card: {
      endpoint: 'https://p1-api.tascadmin.com/card/v1'
    },
    file: {
      endpoint: 'https://p1-api.tascadmin.com/file/v1'
    },
    giving: {
      endpoint: 'https://p1-api.tascadmin.com/giving/v1'
    },
    security: {
      endpoint: 'https://p1-api.tascadmin.com/security/v1'
    },
    support: {
      endpoint: 'https://p1-api.tascadmin.com/support/v1'
    },
    dashboard: {
      endpoint: 'https://p1-api.tascadmin.com/dashboard/v1'
    },
    report: {
      endpoint: 'https://p1-api.tascadmin.com/report/v1'
    },
    paymentAccount: {
      endpoint: 'https://p1-api.tascadmin.com/paymentAccount/v1'
    }
  },

  netSuite: {
    companyId: '3290460',
    baseUrl: 'https://3290460.app.netsuite.com/app/login/secure/oidcprivate.nl',
    cluxHost: 'd3byia5tpzkesl.cloudfront.net',
    landingUrl: {
      billing: 'https://3290460.app.netsuite.com/app/accounting/transactions/transactionlist.nl?Transaction_TYPE=@ALL@',
      invoice: 'https://3290460.app.netsuite.com/app/accounting/transactions/transactionlist.nl?Transaction_TYPE=CustInvc',
      payment: 'https://3290460.app.netsuite.com/app/accounting/transactions/transactionlist.nl?Transaction_TYPE=CustPymt',
      creditMemo: 'https://3290460.app.netsuite.com/app/accounting/transactions/transactionlist.nl?Transaction_TYPE=CustCred',
    },
    myAccountBaseUrl: 'myaccount.benfinityonline.com',
  },
};
